export default __webpack_public_path__ + "static/media/dialogue-left.2a91c0ab.png";